import { SYSTEM_COLLAPSE, USER_COLLAPSE } from 'common/actions/row-groups/types';
import { isStripeExemptRow, StripeExemptRow, StripeRowConfig } from './isStripeExemptRow';

export type StripeRowParity = 'odd' | 'even';

type RowWithParent = StripeExemptRow & {
  alias?: string;
  parent?: string;
  isVisible?: boolean;
};

export const isRowGroupCollapsed = (
  row: RowWithParent,
  rowConfig: RowWithParent[],
  rowGroups: Record<string, string> | undefined
): boolean => {
  if (!rowGroups || !row.parent) {
    return false;
  }

  const getParentAliasOfRow = (rowAlias: string): string | undefined => {
    const configRow = rowConfig.find(configRowItem => configRowItem?.alias === rowAlias);
    return configRow?.parent;
  };

  let current: string | undefined = row.parent;
  const visited = new Set<string>();
  while (current) {
    if (visited.has(current)) {
      break;
    }
    visited.add(current);

    const rowGroup = rowGroups[current];
    if (rowGroup === SYSTEM_COLLAPSE || rowGroup === USER_COLLAPSE) {
      return true;
    }
    current = getParentAliasOfRow(current);
  }

  return false;
};

export const buildStripeRowParityMap = (
  rowConfig: RowWithParent[],
  rowGroups: Record<string, string> | undefined,
  stripeRowConfig: StripeRowConfig = {}
): Map<number, StripeRowParity> => {
  const map = new Map<number, StripeRowParity>();
  let stripeCount = 0;

  for (let rowIndex = 0; rowIndex < rowConfig.length; rowIndex += 1) {
    const row = rowConfig[rowIndex];
    if (
      row.isVisible !== false &&
      !isRowGroupCollapsed(row, rowConfig, rowGroups) &&
      !isStripeExemptRow(row, rowIndex, stripeRowConfig)
    ) {
      map.set(rowIndex, stripeCount % 2 === 0 ? 'odd' : 'even');
      stripeCount += 1;
    }
  }

  return map;
};
